import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import TabMenu from './TabMenu';

const MobileTabMenu = ({ alertCount, handleAlertClick, handleOverviewClick, selectedTab }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'surface.white',
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        top: 'auto',
      }}
    >
      <TabMenu
        alertCount={alertCount}
        handleAlertClick={handleAlertClick}
        handleOverviewClick={handleOverviewClick}
        value={selectedTab}
      />
    </AppBar>
  );
};

MobileTabMenu.propTypes = {
  alertCount: PropTypes.number,
  handleAlertClick: PropTypes.func.isRequired,
  handleOverviewClick: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
};

MobileTabMenu.defaultProps = {
  alertCount: 0,
};

export default MobileTabMenu;
